export const app_faq_icon = 'https://websiteoss.ecoflow.com/app-faq.png';

export const redeem_background_pic = '/static/img/credits/coupon_background_product@2x.png';

export const money_icon = '/static/img/credits/disCount_icon@3x.png';

export const shop_03_Icon = `/static/img/credits/icon_shop_3@3x.png`;

export const shop_04_Icon = `/static/img/credits/icon_shop_4@3x.png`;

export const shop_05_Icon = `/static/img/credits/icon_shop_5@3x.png`;

export const creaditsIcon = '/static/img/credits/sys_integral@3x.png';

export const toCouponDetailIcon = '/static/img/credits/sys_more@3x.png';

export const close_icon = '/static/img/credits/icon_close@2x.png';

export const checked_icon = '/static/img/credits/icon_checked@2x.png';

export const discount_icon = '/static/img/credits/disCount_icon@3x.png';

export const down_more_black_icon = '/static/img/credits/down_more_black@2x.png';

export const down_more_white_icon = '/static/img/credits/down_more_white@2x.png';

export const copy_btn_icon = '/static/img/credits/Icon_24_copy@2x.png';

export const top_header_background_pic = '/static/img/credits/credit_detail_top@2x.png';

export const redeem_coupon_image = '/static/img/credits/coupon_background_image@2x.png';

export const redeem_gift_card_image = '/static/img/credits/gift_card@2x.png';

export const icon_01 = '/static/img/credits/icon_reward@3x.png';

export const icon_02 = '/static/img/credits/sys_more@2x.png';

export const region_Icon = `/static/img/credits/icon_region_switch@3x.png`;

export const survey_result_Icon = `/static/img/pro-survey/result@2x.png`;

export const survey_bubble_Icon = `/static/img/pro-survey/circle@2x.png`;

export const slider_button = `/static/img/pro-survey/button_default.png`;

export const radio_checked_icon = '/static/img/pro-survey/checked.png';

export const radio_un_checked_icon = '/static/img/pro-survey/unchecked.png';

export const checkbox_checked_icon = `/static/img/pro-survey/checkbox_checked@2x.png`;

export const checkbox_un_checked_icon = `/static/img/pro-survey/checkbox_unchecked@2x.png`;
